import * as bootstrap from 'bootstrap';
export class BootstrapCarouselModule {
    constructor() {
        
    }
    initialize = function () {
        var carousels = document.querySelectorAll('.carousel');
        if (carousels) {
            carousels.forEach((carousel) => {
                var c = new bootstrap.Carousel(carousel, {
                    touch: true,
                    wrap: false,
                });
            });
        }
    }
};
export default BootstrapCarouselModule;